import { render } from "./call-sidebar.vue?vue&type=template&id=d46818e0"
import script from "./call-sidebar.vue?vue&type=script&lang=js"
export * from "./call-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__